/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_datasheet__recommendation__not_found_image_alt = /** @type {(inputs: {}) => string} */ () => {
	return `Bib sucht am Horizont`
};

const en_poi_datasheet__recommendation__not_found_image_alt = /** @type {(inputs: {}) => string} */ () => {
	return `Bib searching on the horizon`
};

const es_poi_datasheet__recommendation__not_found_image_alt = /** @type {(inputs: {}) => string} */ () => {
	return `Bib mirando al horizonte`
};

const fr_poi_datasheet__recommendation__not_found_image_alt = /** @type {(inputs: {}) => string} */ () => {
	return `Bib cherchant à l'horizon`
};

const it_poi_datasheet__recommendation__not_found_image_alt = /** @type {(inputs: {}) => string} */ () => {
	return `Bib osserva l’orizzonte`
};

const nl_poi_datasheet__recommendation__not_found_image_alt = /** @type {(inputs: {}) => string} */ () => {
	return `Opkomende Bib Gourmand`
};

const pt_poi_datasheet__recommendation__not_found_image_alt = /** @type {(inputs: {}) => string} */ () => {
	return `Bib procurando no horizonte`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__not_found_image_alt = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_datasheet__recommendation__not_found_image_alt(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_datasheet__recommendation__not_found_image_alt", locale)
	if (locale === "de") return de_poi_datasheet__recommendation__not_found_image_alt(inputs)
	if (locale === "en") return en_poi_datasheet__recommendation__not_found_image_alt(inputs)
	if (locale === "es") return es_poi_datasheet__recommendation__not_found_image_alt(inputs)
	if (locale === "fr") return fr_poi_datasheet__recommendation__not_found_image_alt(inputs)
	if (locale === "it") return it_poi_datasheet__recommendation__not_found_image_alt(inputs)
	if (locale === "nl") return nl_poi_datasheet__recommendation__not_found_image_alt(inputs)
	return pt_poi_datasheet__recommendation__not_found_image_alt(inputs)
};